
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1092_7022)"}},[_c('path',{attrs:{"d":"M5 1.25H1.25A1.25 1.25 0 000 2.5v3.75a1.25 1.25 0 102.5 0v-2.5H5a1.25 1.25 0 100-2.5zm11.25 0H12.5a1.25 1.25 0 100 2.5H15v2.5a1.25 1.25 0 102.5 0V2.5c0-.691-.559-1.25-1.25-1.25zM5 16.25H2.5v-2.5a1.25 1.25 0 10-2.5 0v3.75c0 .691.559 1.25 1.25 1.25H5a1.25 1.25 0 100-2.5zm11.25-3.75A1.25 1.25 0 0015 13.75v2.5h-2.5a1.25 1.25 0 100 2.5h3.75a1.25 1.25 0 001.25-1.25v-3.75c0-.691-.559-1.25-1.25-1.25z","fill":"#9499A6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1092_7022"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h17.5v20H0z"}})])])])
          )
        }
      }
    